import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import styles from "./TripHeader.module.scss";
import type { TripHeaderProps } from "./types";

export const TripHeader = ({
  className,
  statusPill,
  title,
  confirmationCode,
  confirmationLabel,
  tripType,
  segments,
}: TripHeaderProps) => {
  const [block, cn] = useModuleBEM(styles, "TripHeader");
  const { t } = useI18nContext();

  const isMultiCity = tripType && segments && segments.length > 0;

  return (
    <div className={clsx(block, className)}>
      {statusPill}
      {isMultiCity ? (
        <>
          <p className={cn("trip-type")}>{tripType}</p>
          <div className={cn("segments")}>
            {segments.map((segment, index) => (
              <div key={index}>
                <h1 className={cn("title")}>{segment}</h1>
                {index < segments.length - 1 && (
                  <p className={cn("segment-separator")}>
                    {t("flightTrips.and")}
                  </p>
                )}
              </div>
            ))}
          </div>
        </>
      ) : (
        <h1 className={cn("title")}>{title}</h1>
      )}
      <div className={cn("confirmation")}>
        <span className={cn("confirmation-label")}>{confirmationLabel}</span>
        <span className={cn("confirmation-value")}>{confirmationCode}</span>
      </div>
    </div>
  );
};
